/**
 * Adzuki
 * date_time_picker.js
 */

(function DateTimePicker($, Adzuki)
{
	"use strict";

	/**
	 * inits a date/time/datetime picker on el
	 * @param  {jQuery|string} el
	 * @param  {string} input_format  format of date/time displayed in the input
	 * @param  {string} output_format format of date/time submitted by form
	 */
	// http://momentjs.com/docs/#/parsing/string-format/
	var dateTimePicker = function DateTimePicker(el, input_format, output_format)
	{
		var $self,
		    opts = {},
		    display_format,
		    io_format,
		    $hidden_input,
		    $linked_to,
		    $clear_btn,
		    self_dtp,
		    linked_dtp,
		    _link_detection;

		if (el instanceof jQuery) {
			$self = el;
		}
		else {
			$self = $(el);
		}

		if ($self.data('DateTimePicker')) {
			return;
		}

		if ($self.hasClass('no-adzuki-auto-init')) {
			return;
		}

		// init mobile datetimepicker shims
		if (Adzuki.is_mobile) {
			// we want the output format on mobile (native pickers)
			// beacuse it will be what the browser/server expects
			initMobileDTP($self, output_format);
			return;
		}

		// sets the initial expected i/o formats for dates and times
		display_format = $self.data('display-format') || input_format || 'MM/DD/YYYY';
		io_format      = $self.data('io-format') || output_format || 'YYYY-MM-DD';

		// x to clear input button
		$clear_btn = $self.siblings('.clear-datepicker');

		// change input's type, to avoid conflicting native/library UI
		$self.attr('type', 'text');

		// in order to support arbitrary io/display formats, the browser can't
		// be allowed to render a value for what is initially a date/time
		// html5 element, because it will throw a warning and wipe the value.
		// DefaultForm sets the value to data-value, and we swap attributes here
		if ($self.data('value') && $self.data('value') !== '0000-00-00') {
			$self.val($self.data('value'));
			$clear_btn.removeClass('hidden');
		}

		// to be able to address it via css/js if needed
		$self.addClass('adzuki-datetimepicker');

		// append hidden input AFTER display input, preserve bootstrap styling
		$hidden_input = $('<input type="hidden">')
		    .attr('id', $self.attr('id') + '_hidden')
		    .attr('name', $self.attr('name'))
		    .val($self.data('value'))
		    .insertAfter($self);

		// remove input name, so it's ignored by form post
		$self.removeAttr('name');

		// removes the readonly attribute, if desired.
		// you shouldn't desire this.
		if ($self.data('enable-manual-edit')) {
			$self.removeAttr('readonly');
		}

		// set datetimepicker options
		opts.format         = display_format; // input display format
		opts.extraFormats   = [display_format, io_format]; // formats to parse
		opts.useCurrent     = false;
		opts.ignoreReadonly = true;
		opts.calendarWeeks  = true;
		opts.icons          = {
			time    : Adzuki.FaIcon.getIconStyle('clock', 'solid'),
			date    : Adzuki.FaIcon.getIconStyle('calendar', 'solid'),
			up      : Adzuki.FaIcon.getIconStyle('chevron_up', 'solid'),
			down    : Adzuki.FaIcon.getIconStyle('chevron_down', 'solid'),
			previous: Adzuki.FaIcon.getIconStyle('chevron_left', 'solid'),
			next    : Adzuki.FaIcon.getIconStyle('chevron_right', 'solid'),
			today   : Adzuki.FaIcon.getIconStyle('dot_circle', 'solid'),
			clear   : Adzuki.FaIcon.getIconStyle('trash', 'solid'),
			close   : Adzuki.FaIcon.getIconStyle('close', 'solid'),
		};

		if ($self.attr('max')) {
			opts.maxDate = moment($self.attr('max'));
		}

		if ($self.attr('min')) {
			opts.minDate = moment($self.attr('min'));
		}

		if ($self.attr('stepping')) {
			opts.stepping = $self.attr('stepping');
		}

		if ($self.data('view-mode')) {
			opts.viewMode = $self.data('view-mode');
		}

		if ($self.data('view-date')) {
			opts.viewDate = moment($self.data('view-date'));
		}

		// when i die bury me inside a louis store
		if ($self.data('mode') === 'birthday') {
			opts.minDate  = moment('1900-01-01');
			opts.maxDate  = moment();
			opts.viewDate = moment('1900-01-01');
			opts.viewMode = 'decades';
		} else if ($self.data('mode') === 'credit-card') {
			opts.minDate  = moment();
			opts.viewMode = 'years';
			opts.format   = 'MM/YYYY';
		}

		// init datetimepicker
		$self.datetimepicker(opts);
		self_dtp = $self.data('DateTimePicker');

		// set up linked pickers
		if ($self.data('linked-to')) {
			$linked_to = $($self.data('linked-to'));

			// update linked pickers on change
			$linked_to.on('dp.change', function _updateLinkedPicker(e) {
				self_dtp.maxDate(e.date);
			});

			// the linked datetimepicker probably hasn't fully initialized
			// by this point, so detect when it is to save the dtp reference.
			// this happens very quickly; in my tests, this only ever runs once.
			_link_detection = setInterval(function _detectLinkedPicker() {
				linked_dtp = $linked_to.data('DateTimePicker');

				// set initial boundaries for linked pickers
				if (linked_dtp !== undefined) {
					clearInterval(_link_detection);

					if (self_dtp.date() !== null) {
						linked_dtp.minDate(self_dtp.date());
					}

					if (linked_dtp.date() !== null) {
						self_dtp.maxDate(linked_dtp.date());
					}
				}
			}, 100);
		}

		// update hidden input with the proper date
		$self.on('dp.change', function updateHiddenField(e)
		{
			var date = null;

			if (e.date) {
				date = moment(e.date._d).format(io_format);

				// update linked picker
				if ($linked_to && linked_dtp) {
					linked_dtp.minDate(e.date);
				}

				$clear_btn.removeClass('hidden');
			} else {
				$clear_btn.addClass('hidden');
			}

			$hidden_input.val(date);
		});

		// show picker when clicking on the calendar icon.
		// normally you'd init the datepicker on the .input-group parent, but
		// it was causing edge cases where it'd submit the wrong date format.
		$self.siblings('.input-group-addon').on('click', function showPicker() {
			self_dtp.show();
		});

		// clear input button
		$clear_btn.on('click', function clearDTP(event)
		{
			if ($self.is(':disabled')) {
				Adzuki.StatusMessage('info', 'This input is disabled and cannot be changed right now.', 'Info');
				return;
			}

			Adzuki.CustomConfirm({
				body   : 'Are you sure you wish to clear this field?',
				confirm: function confirm() {
					self_dtp.clear();
					$hidden_input.val('');
					$clear_btn.addClass('hidden');
				}
			});
		});
	};




	// mobile datetimepickers use their respective native implementations.
	// this creates api and event shims so code works as expected in mobile.
	function initMobileDTP($el, input_format)
	{
		var _input_format = input_format || 'YYYY-MM-DD',
		    _dt_modifier  = 'second',
		    _dtval;

		// api shim
		$el.data('DateTimePicker', {
			date: function date(argv, init) {
				// date() - no args, return the current value as a moment
				if (typeof argv === 'undefined') {
					return moment($el.val());
				}
				// date(null|false) - null/false arg, clear input
				else if (argv === null || argv === false) {
					this.clear();
					return;
				}
				// date('Y-m-d') - string arg, format and set input value
				else if (typeof argv === 'string') {
					_dtval = moment(argv, _input_format);
				}
				// date(moment) - moment arg, format and set input value
				else if (argv._isAMomentObject) {
					_dtval = argv;
				}
				// date(new Date()) - date object arg, set input value
				else if (typeof argv.getYear === 'function') {
					_dtval = moment();
				}

				if (init) {
					// fixes a weird iOS bug (unconfirmed for android):
					// iOS will not display the value the first time you set it,
					// you need to set it to a different value, then re-set it
					// back to the original value.
					// so, add 1 day/second to the date/time, then subtract it
					if (_input_format.indexOf('YYYY') >= 0) {
						_dt_modifier = 'day';
					}

					$el.val(_dtval.add(1, _dt_modifier).format(_input_format));
					$el.val(_dtval.subtract(1, _dt_modifier).format(_input_format));
				} else {
					$el.val(_dtval.format(_input_format));
				}

			},
			clear: function clear() {
				$el.val('');
			},
			minDate: function minDate(argv) {
				$el.attr('min', argv);
			},
			maxDate: function maxDate(argv) {
				$el.attr('max', argv);
			}
		});

		// event shim
		$el.on('change', function change() {
			// only trigger shim change event if not clearing the value
			if ($el.val().length) {
				$el.trigger({
					type: 'dp.change',
					date: moment($el.val()),
				});
			}
		});

		$el.data('DateTimePicker').date($el.data('value'), true);
	}

	Adzuki.DateTimePicker = dateTimePicker;
}(jQuery, window.Adzuki || {}));
